import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import WelcomeBanner from './WelcomeBanner';

const Layout = ({ children }) => {
    return (
        <div className="flex h-screen w-screen overflow-hidden">
            <Sidebar />
            <div className="flex flex-col flex-1 overflow-hidden">
                <Header />
                <main className="flex-1 overflow-auto p-10">
                    <WelcomeBanner />
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;
